import { render } from "./InfoBox.vue?vue&type=template&id=3ef865e1&scoped=true"
const script = {}

import "./InfoBox.vue?vue&type=style&index=0&id=3ef865e1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef865e1"]])

export default __exports__